export default __webpack_public_path__ + "static/media/difficulty.7de9cac6.svg";